import { useQuery } from '@tanstack/react-query';

import AppApi from '@/apis/app-api';
import SubscriptionApi from '@/apis/subscription';
import { baseUrl } from '@/consts/route';
import { billingKeys } from '@/data/billing/keys';
import { Subscription } from '@/types/subscription';

import { useAuth } from './useAuth';

export const useSubscription = (
  { intervalRetry = false }: { intervalRetry?: boolean } = {
    intervalRetry: false,
  },
) => {
  const { accessToken, email, userId } = useAuth();
  const fetchSubscription = async () => {
    const api = new AppApi(baseUrl + `/users/${userId}`);
    const subscriptionApi = new SubscriptionApi(api);
    api.setup(accessToken);
    const res = await subscriptionApi.getSubscription();
    return res ?? ({} as Subscription);
  };

  return useQuery({
    queryFn: fetchSubscription,
    queryKey: billingKeys.subscription(email),
    enabled: !!accessToken && !!userId,
    refetchInterval: intervalRetry ? 3000 : false,
    // 구독 상태 단일 SoT. 결제/변경 직후 페이지 이동 시 stale 캐시로 요금제 변경
    // 가드(SCHEDULE_CONFLICT 등)가 오작동하던 버그 → 진입마다 최신 재조회.
    staleTime: 0,
  });
};

export const useReservedSubscription = () => {
  const { accessToken, email, userId } = useAuth();
  const fetchSubscription = async () => {
    const api = new AppApi(baseUrl + `/users/${userId}`);
    const subscriptionApi = new SubscriptionApi(api);
    api.setup(accessToken);
    const res = await subscriptionApi.getReservedSubscription();
    return res ?? ({} as Subscription);
  };

  return useQuery({
    queryFn: fetchSubscription,
    queryKey: billingKeys.reservedSubscription(email),
    enabled: !!accessToken && !!userId,
    // 다음 예약 구독 단일 SoT. 결제/변경 직후 다음 결제정보가 안 뜨거나 옛 예약이
    // 남던 버그 → 진입마다 최신 재조회.
    staleTime: 0,
  });
};
